export const brand = {
  title: 'Quiz',
  description: 'Quiz description',
  image_url: '/logo.png',
  navbar_logo_url: '/navbar_logo_new.png',
  rules: 'T & C',
  neutral_text: `Winners will be announced later`,
  fail_text: 'Try later',
  win_text: `You won!`,
  sorry_text: `Sorry, there are no quizzes live right now. Check back later!`,
};

export const api_url = 'https://hip-mule-192.hasura.app/v1/graphql';
